import design from '@/config/design';
import { colorPallets } from '@/components/widget/visualizations/GaugeChart/settings';
export const widgetConfig = {
  layout: 'none',
  styles: {
    widgetHeight: '100%',
    widgetMaxWidth: '100%',
    widgetPaddingTop: '0',
    widgetPaddingRight: '0',
    widgetPaddingBottom: '0',
    widgetPaddingLeft: '0',
    gridCellMaxHeight: '100%'
  }
};
export const chartSectionStyles = {
  height: '100%'
};
export const sectionLgPadding = {
  paddingTop: design.globals.lgPadding,
  paddingRight: design.globals.lgPadding,
  paddingBottom: design.globals.lgPadding,
  paddingLeft: design.globals.lgPadding
};
export const colorSchemeBySection = {
  GaugeChart: {
    colorPallets: colorPallets
  }
};